import {STATE_PROP} from './entities-constants'

export const getEntities = state => state[STATE_PROP]
